
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();
import  EtapVue  from "./Etap.vue"
import { Tree } from "./Tree";
import  ButtonVue from "@/lib/Button.vue";

type TypEtapu = {
  etap_nazwa:string;
  etap_typ:string;
}


@Component({ components: { EtapVue, ButtonVue} })
export default class TreeShortVue extends Vue {
 
  @Prop(Object) tree_prop:any;
  tree!:Tree;
  id:string|undefined = "";

  key:number=0;

  get selected() {
    if (!this.$route.params.id) return 'rowshadow';
    if (this.$route.params.id==this.id ) return 'rowshadow selected-row';
    return 'rowshadow';
  }

  async refresh() {
     if (this.tree_prop) {
      //console.log("TreeShort: refresh using tree_prop",this.tree_prop)

      this.tree=this.tree_prop;
      (<any>this.tree).selected=false;
      this.id=this.tree_prop._id;
      this.key++;
    }
  }

  async del_tree(id:string) {
    alert("TODO")
  }

  async mounted() {
    
    await this.refresh();
  }

  num(x:number):string {
    if (!x) return '   .0'
    const s='   '+Number.parseFloat(x.toString()).toFixed(1);
    const l=s.length
    return s.substring(5-l)

  }
}
